// extracted by mini-css-extract-plugin
export default {"video":"Video_video__9SbeR","video__caption":"Video_video__caption__gaCeJ"};